"use strict";

function openLevel(event, levelName) {
  // Declare all variables
  var i, tabcontent, tablinks; // Get all elements with class="lhg-table" and hide them

  tabcontent = document.getElementsByClassName("lhg-table");

  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  } // Get all elements with class="tablinks" and remove the class "active"


  tablinks = document.getElementsByClassName("tablinks");

  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  } // Show the current tab, and add an "active" class to the button that opened the tab


  document.getElementById(levelName).style.display = "block";
  event.currentTarget.className += " active";
} //The following are 2 diff implementations of the same function for scroll to top on click. on is smooth scroll, other is regular scroll
// When the user clicks on the button, scroll to the top of the document - regular scroll


function topFunction() {
  document.body.scrollTop = 0; // For Safari

  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
} // When the user clicks on the button, smooth scroll to the top of the document - smooth scroll - this one is hooked up at the moment


function scrollToTop() {
  var position = document.body.scrollTop || document.documentElement.scrollTop;

  if (position) {
    window.scrollBy(0, -Math.max(1, Math.floor(position / 10)));
    scrollAnimation = setTimeout("scrollToTop()", 30);
  } else clearTimeout(scrollAnimation);
} // Get the element with id="defaultOpen" and click on it


document.getElementById("defaultOpen").click();